module.exports = __webpack_public_path__ + "img/img_banner_01.a9c55924.jpg";